import * as moment from 'moment';

export const validators = (ruleName: string, ruleCondition: number | string | RegExp | boolean, value: string) => {
    let result: string = '';
    switch (ruleName) {
        case 'required':
            if (ruleCondition && !((typeof value === 'boolean' || typeof value === 'number' || value) && value.toString() ? value.toString().length > 0 : false)) {
                result = ' is required';
            }
            return result;

        case 'maxLength':
            if (Array.isArray(ruleCondition)) {
                if (!(value ? value.length <= Number(ruleCondition[0]) : true)) {
                    result = ' ' + ruleCondition[1];
                }
            } else {
                if (!(value ? value.length <= Number(ruleCondition) : true)) {
                    result = ' ' + ruleCondition + ' characters is maximum';
                }
            }
            return result;

        case 'noWhiteSpace':
            if (ruleCondition && (value ? value.match(/^\s|\s$/) : false)) {
                result = ' must not have leading and trailing white space';
            }
            return result;

        case 'format':
            if (Array.isArray(ruleCondition)) {
                if (!(value ? value.match(ruleCondition[0]) : true)) {
                    result = ' ' + ruleCondition[1];
                }
            } else {
                if (!(value ? String(value).match(ruleCondition as string | RegExp) : true)) {
                    result = ' is invalid';
                }
            }
            return result;

        case 'email':
            if (ruleCondition && value && !/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/.test(value)) {
                return ' is invalid';
            }

            return '';

        case 'phoneNumber':
            if (ruleCondition && value && !/^\(\d{3}\) \d{3}-\d{4}$/.test(value)) {
                return ' is invalid';
            }

            return '';

        case 'npi':
            if (ruleCondition && value && !/^\d{10}$/.test(value)) {
                return ' is invalid';
            }

            return '';

        case 'password':
            if (ruleCondition && value && !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*?]{8,}$/.test(value)) {
                return ' is invalid';
            }

            return '';

        case 'pinCode':
            if (ruleCondition && value && !/^[0-9]{6}$/.test(value)) {
                return ' must be 6 (six) digits';
            }

            return '';

        case 'notInTheFuture':
            if (ruleCondition && value && moment(value, 'MM/DD/YYYY').isValid()) {
                if (moment(value, 'MM/DD/YYYY').format('YYYYMMDD') > moment().format('YYYYMMDD')) {
                    result = ' must not be in the future';
                }
            }
            return result;

        case 'notInThePast':
            if (ruleCondition && value && moment(value, 'MM/DD/YYYY').isValid()) {
                if (moment(value, 'MM/DD/YYYY').format('YYYYMMDD') < moment().format('YYYYMMDD')) {
                    result = ' must not be in the past';
                }
            }
            return result;
        
        case 'validDateFormat':
            if (ruleCondition && value) {                
                if (moment(value, 'MM/DD/YYYY').isValid()) {
                    return result;
                } else {
                    result = ' must be a valid date in the format mm/dd/yyyy';
                }
            }
            return result;

        case 'integerRange':
            const numberIR = Number(value);
            if (!(value ? (ruleCondition && Number.isInteger(numberIR) && numberIR >= ruleCondition[0] && numberIR <= ruleCondition[1]) : true)) {
                result = ' must be an integer between ' + ruleCondition[0] + ' and  ' + ruleCondition[1];
            }
            return result;

        case 'positiveNumber':
            const numberPN = Number(value);
            if (ruleCondition) {
                let min = 1;
                for (let i = 0; i < ruleCondition; i++) {
                    min = min / 10;
                }
                if (!(value ? (!Number.isNaN(numberPN) && numberPN >= min && numberPN.toString().match('^[^ ]*$') && numberPN.toString().split('.').join('').length <= ruleCondition) : true)) {
                    result = ' must be a positive integer or decimal number with maximum ' + ruleCondition + ' digits';
                }
            }
            return result;

        case 'notNegativeNumber':
            const numberNNN = Number(value); // not negative number: can be = 0
            if (ruleCondition) {
                if (!(value ? (!Number.isNaN(numberNNN) && numberNNN >= 0 && numberNNN.toString().match('^[^ ]*$') && numberNNN.toString().split('.').join('').length <= ruleCondition) : true)) {
                    result = ' must be a not negative integer or decimal number with maximum ' + ruleCondition + ' digits';
                }
            }
            return result;

        case 'match':
            if (value !== ruleCondition) {
                return ' does not match';
            }
            return result;

        default:
            return '';
    }
};

export const checkErrorForm = (validationRules: Object, data: Object) => {
    return Object.keys(validationRules).some(validationRule => {
        return Object.keys(validationRules[validationRule]).some(rule => {
            return validators(rule, validationRules[validationRule][rule], data[validationRule]).length > 0;
        });
    });
};

export function isValid(value: string, ruleMap: {}): boolean {
    for (let rule of Object.keys(ruleMap)) {
        if (validators(rule, ruleMap[rule], value).length) {
            return false;
        }
    }

    return true;
}

export const medicationRules = {
    directionInSig: {
        required: true
    },
    directionInSigText: {
        required: true
    },
    directionInFreeText: {
        required: true,
        maxLength: [140, 'must not exceed 140 characters'],
        format: ['^(\\S.*)?\\S$', 'must not include leading or trailing whitespace or new line']
    },
    unit: {
        required: true
    },
    quantity: {
        required: true,
        positiveNumber: 10
    },
    daySupply: {
        integerRange: [1, 999]
    },
    refill: {
        required: true,
        integerRange: [0, 99]
    }
};


// WEBPACK FOOTER //
// ./src/utils/ehrValidators.ts